import * as actionTypes from "../actions/actionTypes";

const initialState = [];

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SERVICES:
      console.log(action);
      return action.services;
    default:
      return state;
  }
};

export default reducer;
